import React from 'react';
import { Reveal } from './Reveal';
type Volume = {
  number: string;
  title: string;
  subtitle: string;
  description: string;
  tags: string[];
  featured?: boolean;
};
const volumes: Volume[] = [{
  number: 'TOME 01',
  title: '🌌 Les Lois Systémiques',
  subtitle: 'Les Ordres de l’Amour',
  description: 'Chaque famille fonctionne selon 3 lois invisibles. Quand elles se brisent, la douleur se répète entre les générations. Apprenez à lire votre système et à cartographier les forces cachées qui gouvernent votre vie.',
  tags: ['Lois Systémiques', 'Cartes Familiales', 'Schémas Illustrés', 'Phrases de Guérison']
}, {
  number: 'TOME 02',
  title: '🌸 La Blessure de la Mère',
  subtitle: 'Guérir le Lien à la Source de la Vie',
  description: 'Votre lien avec votre mère peut influencer votre estime de vous-même et certaines dynamiques relationnelles. Restaurez la connexion la plus fondamentale qu’un être humain puisse avoir.',
  tags: ['Blessure Maternelle', 'Scripts de Guérison', 'Protocoles Cliniques', 'Imprimable'],
  featured: true
}, {
  number: 'TOME 03',
  title: '⚡ La Force du Père',
  subtitle: 'Récupérer sa Puissance dans le Monde',
  description: 'La relation paternelle peut influencer votre confiance, votre autonomie et votre rapport au monde. Libérez le jugement et récupérez la force qui vous revient de droit.',
  tags: ['Blocages Financiers', 'Confiance', 'Puissance', 'Protocoles']
}, {
  number: 'TOME 04',
  title: '🌑 L’Ombre des Ancêtres',
  subtitle: 'Briser les Loyautés Invisibles',
  description: 'Les secrets de famille et les tragédies oubliées vivent en vous comme des loyautés invisibles. Libérez-vous des destins qui n’ont jamais été les vôtres à porter.',
  tags: ['Cartes Ancestrales', 'Loyautés Transgénérationnelles', 'Libération', 'Schémas Illustrés'],
  featured: true
}, {
  number: 'TOME 05',
  title: '💫 L’Architecture de l’Enfant Intérieur',
  subtitle: 'Guérir le Système depuis l’Origine',
  description: 'L’enfant blessé en vous prend des décisions d’adulte. Guérissez les cinq blessures émotionnelles fondamentales qui alimentent vos schémas les plus profonds.',
  tags: ['Enfant Intérieur', '5 Blessures', 'Reparentage Systémique', 'Cartes Pratiques']
}, {
  number: 'TOME 06',
  title: '✨ Réécrire son Destin',
  subtitle: 'Intégration et Nouveau Récit',
  description: 'De nouveaux rituels, un génogramme de solution et un plan d’intégration de 30 jours. Ancrez votre guérison et écrivez l’héritage que vous seul pouvez laisser.',
  tags: ['Plan 30 Jours', 'Génogramme de Solution', 'Nouveaux Rituels', 'Votre Héritage']
}];
export function Modules() {
  return <section className="w-full bg-mist px-4 py-20 sm:py-24" data-id="element-144" data-mp="2vm31gq1tal1y">
      <div className="mx-auto max-w-6xl" data-id="element-145" data-mp="3jcyq5eaz104z">
        <Reveal className="mx-auto max-w-3xl text-center" data-id="element-146" data-mp="3jbxcr36hg1k3">
          <h2 className="font-serif text-4xl text-navy sm:text-5xl" data-id="element-147" data-mp="3o5a0zc7926cb">
            📚 6 Tomes <span className="text-sage" data-id="element-148" data-mp="1coq01w6a38ah">thérapeutiques complets</span>
          </h2>
          <p className="mt-5 text-slate" data-id="element-149" data-mp="17qy8x4dgjq7c">
            Chaque blessure couverte. Chaque schéma décodé. Chaque outil prêt à imprimer et à utiliser aujourd’hui.
          </p>
        </Reveal>
        <div className="mt-10 grid gap-5 md:grid-cols-2" data-id="element-150" data-mp="1hghsydcwpq3s">
          {volumes.map((volume, index) => <Reveal key={volume.number} delay={index % 2 * 0.06} className="h-full" data-id="element-151" data-mp="tqdo62nzfkb7" data-mpi={index}>
              <article className={`flex h-full flex-col rounded-2xl border bg-surface p-8 shadow-premium ${volume.featured ? 'border-amber/50' : 'border-navy/10'}`} data-id="element-152" data-mp="orkdei02y7eq">
                <p className="text-xs font-bold uppercase tracking-[0.15em] text-sage" data-id="element-153" data-mp="ypqdqv68n5hh">{volume.number}</p>
                <h3 className="mt-4 font-serif text-2xl leading-tight text-navy" data-id="element-154" data-mp="2f3q87qmbe2xc">{volume.title}</h3>
                <p className="mt-1 font-serif text-lg italic leading-snug text-amber" data-id="element-155" data-mp="2a55iwm8lp3no">{volume.subtitle}</p>
                <p className="mt-4 flex-1 text-sm leading-7 text-slate" data-id="element-156" data-mp="jobelm7cki0l">{volume.description}</p>
                <ul className="mt-6 flex flex-wrap gap-2" data-id="element-157" data-mp="omlda6sa60qy">
                  {volume.tags.map(tag => <li key={tag} className="rounded-full bg-amber-pale px-3 py-1.5 text-xs font-semibold text-navy" data-id="element-158" data-mp="snygsa7whrup">
                      {tag}
                    </li>)}
                </ul>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}